import React, { FC, memo, useCallback } from "react"
import { observer } from "mobx-react-lite"
import { FlagIcon } from "@btc-alpha/ui-components"

import useLanguages from "hooks/newUI/header/useLanguages"
import LanguageCheck from "assets/icons/header/LanguageCheck"

import styles from "layouts/RedesignedLayout/navigation/contents/Languages/index.module.scss"

type LanguagesItemTypes = {
	label: string
	value: string
	country: string
	isChecked: boolean
	handleChange: (lang: string) => void
}

const LanguagesItem: FC<LanguagesItemTypes> = ({ label, value, country, isChecked, handleChange }) => {
	const onClick = useCallback(() => {
		handleChange(value)
	}, [value])

	return (
		<button type="button" onClick={onClick} className={styles.languages__item}>
			<FlagIcon name={country} size={20} round />
			<span>{label}</span>
			{isChecked ? (
				<span className={styles.nav__langButtonCheck}>
					<LanguageCheck />
				</span>
			) : null}
		</button>
	)
}

const Languages: FC = () => {
	const { appLocales, handleLocaleChange, globalLocale } = useLanguages()

	return (
		<div className={styles.languages}>
			{appLocales.map(({ name, value, country }) => (
				<LanguagesItem
					key={name}
					isChecked={value === globalLocale}
					handleChange={handleLocaleChange}
					value={value}
					label={name}
					country={country}
				/>
			))}
		</div>
	)
}

export default observer(Languages)
